import { useEffect } from 'react'

import { useReduxDispatch } from '@/store/hooks'
import { viewActions } from '@/store/view'

export const KeyboardListener = () => {
  const dispatch = useReduxDispatch()

  useEffect(() => {
    const onKeyUp = (e: KeyboardEvent) => {
      if (e.altKey || e.ctrlKey || e.metaKey || e.defaultPrevented) return

      if (e.key === '/') {
        if (
          !(e.target instanceof HTMLElement) ||
          e.target.isContentEditable ||
          ['INPUT', 'SELECT', 'TEXTAREA'].includes(e.target.tagName) ||
          document.querySelector('[role="dialog"][data-state="open"]')
        )
          return

        const searchbar = document.getElementById('searchbar')

        if (!searchbar) return

        e.preventDefault()
        searchbar.focus()
      }

      if (e.key === 'Escape') {
        dispatch(viewActions.closeMobileMenus())
        dispatch(viewActions.collapseSidebars())
      }
    }

    window.addEventListener('keyup', onKeyUp)

    return () => {
      window.removeEventListener('keyup', onKeyUp)
    }
  }, [dispatch])

  return null
}
